/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type { CamelToSnake } from "../wire/transform";
import type {
  CreateStickyTypeRequest,
  CreateStickyTypeResponse,
  GetStickyTypeResponse,
  GetStickyTypesResponse,
  NoData,
  UpdateStickyTypeRequest,
} from "./models";
import {
  createStickyTypeResponseSchema,
  getStickyTypeResponseSchema,
  getStickyTypesResponseSchema,
  noDataSchema,
} from "./schemas";

export class StickyTypeApiClient {
  constructor(private caller: ApiCaller) {}

  async getStickyTypes(sessionId: string, timeout?: number): Promise<GetStickyTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky_type.v1.sessions.${sessionId}.sticky_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getStickyTypes",
      {},
      { schema: getStickyTypesResponseSchema, timeout },
    );
  }

  async createStickyType(
    payload: CamelToSnake<CreateStickyTypeRequest>,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateStickyTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky_type.v1.sessions.${sessionId}.sticky_types.create",
        variables: { sessionId: String(sessionId) },
      },
      "createStickyType",
      payload,
      { schema: createStickyTypeResponseSchema, rawRequest: true, timeout },
    );
  }

  async getStickyType(stickyTypeId: string, timeout?: number): Promise<GetStickyTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky_type.v1.sticky_types.${stickyTypeId}.get",
        variables: { stickyTypeId: String(stickyTypeId) },
      },
      "getStickyType",
      {},
      { schema: getStickyTypeResponseSchema, timeout },
    );
  }

  async updateStickyType(
    payload: UpdateStickyTypeRequest,
    stickyTypeId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky_type.v1.sticky_types.${stickyTypeId}.update",
        variables: { stickyTypeId: String(stickyTypeId) },
      },
      "updateStickyType",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteStickyType(stickyTypeId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky_type.v1.sticky_types.${stickyTypeId}.delete",
        variables: { stickyTypeId: String(stickyTypeId) },
      },
      "deleteStickyType",
      {},
      { schema: noDataSchema, timeout },
    );
  }
}
